import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home'; 
import TelemedicinePage from './pages/TelemedicineApps';
// import DataAnalysis from './pages/DataAnalysisApps';
import DigitalHealthProductManagement from './pages/DPManagement';
// import InteroperabilityProjects from './pages/Interoperability';
import Resume from './pages/resume';
import Aboutme from './pages/Aboutme';
import Layout from './components/Layout';
import Fun from './pages/Fun';
import ServerAPIs from './pages/ServerApi';

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/telemedicine" element={<TelemedicinePage />} />
          <Route path="/casestudies" element={<DigitalHealthProductManagement />} />
          <Route path="/aboutme" element={<Aboutme />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/funprojects" element={<Fun />} />
          <Route path="/serverApi" element={<ServerAPIs />} />
          {/*<Route path="/dataanalysis" element={<DataAnalysis />} />
          <Route path="/interop" element={<InteroperabilityProjects />} />*/}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
